import { Scoreboard } from "./../../data";
import { ScoreboardTennisParser } from "./ScoreboardTennisParser";
import { eBranches } from "sb-resp-lib";
import { entities } from "sbtech-sports-data-api-client";

export class ScoreboardParser {
    private static _instance: ScoreboardParser;

    private constructor() { }

    public static get instance(): ScoreboardParser {
        if (!ScoreboardParser._instance) {
            ScoreboardParser._instance = new ScoreboardParser();
        }
        return ScoreboardParser._instance;
    }

    public parse(sportEvent: entities.SportEvent, sportId: string, isTeamSwap: boolean): Scoreboard | undefined {
        switch (Number(sportId)) {
            case eBranches.Tennis: return ScoreboardTennisParser.instance.parse(sportEvent, isTeamSwap);
        }

        return undefined;
    }
};